import React, { useRef, useEffect, useState } from 'react';
import { Form, Input, Button, message } from 'antd';
import { layout, tailLayout } from './constant';
import ApiServices from '~services';
import { Selection } from '~components';

const SupplierMaterialForm = ({
  fields,
  isNew,
  id,
  reload,
  onChange,
  setLoading,
  dataSelected,
}) => {
  const inputRef = useRef(null);
  const [companies, setCompanies] = useState([]);

  const getCompanies = async (query = '') => {
    const newQuery = {
      Columns: {
        name: query,
      },
    };
    try {
      const res = await ApiServices.getCompanies(query ? newQuery : null);
      if (res?.data?.data) {
        setCompanies(res?.data?.data || []);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getCompanies();
  }, []);

  const onCompareWithApi = (value, cb) => {
    if (inputRef.current) {
      clearTimeout(inputRef.current);
      cb();
    }
    inputRef.current = setTimeout(async () => {
      try {
        const { data } = await ApiServices.existsSupplierMaterial(null, value);
        const isUsed = data;
        cb(isUsed);
      } catch (error) {
        console.error(error);
      }
    }, 1000);
  };

  const checkExistsCode = async (_, value) => {
    if (value.length > 2) {
      const ind = fields.findIndex((item) => {
        return item.name[0] === 'code';
      });
      if (isNew === false && value !== fields[ind].value) {
        try {
          const waitMe = () =>
            new Promise((resolve, reject) => {
              onCompareWithApi(value, (isUsed) => {
                if (typeof isUsed !== 'undefined') {
                  if (isUsed) reject();
                  resolve();
                }
              });
            });
          await waitMe();
        } catch (error) {
          return Promise.reject(new Error('Mã NCC này đã tạo rồi !!!'));
        }
      }

      if (isNew === true) {
        try {
          const waitMe = () =>
            new Promise((resolve, reject) => {
              onCompareWithApi(value, (isUsed) => {
                if (typeof isUsed !== 'undefined') {
                  if (isUsed) reject();
                  resolve();
                }
              });
            });
          await waitMe();
        } catch (error) {
          return Promise.reject(new Error('Mã NCC này đã tạo rồi !!!'));
        }
      }
    }
  };

  const createdSupplierMaterial = async (data) => {
    try {
      const res = await ApiServices.createSupplierMaterial(data);
      if (res.data) {
        message.success('Thêm mới NCC thành công');
        return reload();
      } else {
        message.error('Thêm mới NCC thất baị, vui lòng kiểm tra lại thông tin');
      }
    } catch (err) {
      message.error('Thêm mới NCC thất baị, vui lòng kiểm tra lại thông tin');
      console.error(err);
    }
  };
  const updatedSupplierMaterial = async (data) => {
    data.id = id;
    try {
      const res = await ApiServices.updateSupplierMaterial(id, data);
      if (res.data) {
        message.success('Cập nhật NCC thành công');
        return reload();
      } else {
        message.error('Cập nhật NCC thất baị, vui lòng kiểm tra lại thông tin');
      }
    } catch (err) {
      message.error('Cập nhật NCC thất baị, vui lòng kiểm tra lại thông tin');
      console.error(err);
    }
  };
  const onSubmitForm = async (value) => {
    if (isNew) {
      setLoading(true);
      await createdSupplierMaterial(value);
      setLoading(false);
      return;
    }
    setLoading(true);
    await updatedSupplierMaterial(value);
    setLoading(false);
  };
  return (
    <Form
      {...layout}
      name='global_state'
      onFinish={onSubmitForm}
      fields={fields}
      onFieldsChange={(_, allFields) => {
        onChange(allFields);
      }}
    >
      <Form.Item
        // {...itemLayout}
        style={{ marginTop: '10px' }}
        name='code'
        label='Mã NCC'
        rules={[
          {
            required: true,
            message: 'bạn phải nhập Mã NCC',
          },
          {
            validator: checkExistsCode,
          },
          {
            type: 'string',
            min: 3,
            message: 'Bạn phải nhập ít nhất 3 ký tự',
          },
        ]}
      >
        <Input placeholder='Mã NCC' />
      </Form.Item>
      <Form.Item
        style={{ marginTop: '10px' }}
        name='name'
        label='Tên NCC'
        rules={[
          {
            required: true,
            message: 'Bạn phải nhập tên NCC',
          },
        ]}
      >
        <Input placeholder='Tên NCC' />
      </Form.Item>
      <Form.Item name='address' label='Địa Chỉ'>
        <Input.TextArea placeholder='Địa Chỉ' />
      </Form.Item>
      <Form.Item name='phone' label='Điện thoại'>
        <Input placeholder='Điện thoại' />
      </Form.Item>
      <Form.Item
        name='email'
        label='Email'
        rules={[
          {
            type: 'email',
            message: 'Bạn đã nhập sai email.',
          },
        ]}
      >
        <Input placeholder='Email' />
      </Form.Item>
      <Form.Item name='fax' label='Fax'>
        <Input placeholder='Fax' />
      </Form.Item>
      <Form.Item name='representative' label='Người Đại Diện'>
        <Input placeholder='Người Đại Diện' />
      </Form.Item>
      <Form.Item
        name='companyId'
        label='Công Ty'
        rules={[
          {
            required: true,
            message: 'Bạn phải chọn Công Ty',
          },
        ]}
      >
        <Selection
          labelDefault={dataSelected?.companyName || ''}
          data={companies}
          placeholder='Bạn phải chọn Công Ty'
          fieldValue='name'
          onSearch={getCompanies}
        />
      </Form.Item>
      <Form.Item name='note' label='Ghi Chú'>
        <Input.TextArea placeholder='Ghi Chú' />
      </Form.Item>
      <Form.Item {...tailLayout}>
        <Button type='primary' htmlType='submit'>
          {isNew ? 'Thêm Mới' : 'Cập nhật'}
        </Button>
      </Form.Item>
    </Form>
  );
};

export { SupplierMaterialForm };
